import "./consumptionForecast.css";
import Header from "./subComponents/header";
import Footer from "./subComponents/footer";
import Patterns from "./subComponents/patterns";
import { useSelector } from "react-redux";
import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Filler,
  BarElement,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Filler,
  BarElement,
  Legend
);

const labels = ["Generated", "Consumed", "Exported", "Imported", "Standby"];
let lim = 10000;

function energyCalculations(givenData) {
  let data = {
    [labels[0]]: [],
    [labels[1]]: [],
    [labels[2]]: [],
    [labels[3]]: [],
    [labels[4]]: [],
  };
  givenData[labels[0]].forEach((item, index) => {
    data[labels[0]][index] = item;
    data[labels[1]][index] = -givenData[labels[1]][index];
    if (item === givenData[labels[1]][index]) {
      data[labels[2]][index] = null;
      data[labels[3]][index] = null;
    } else if (item > givenData[labels[1]][index]) {
      data[labels[2]][index] = -(item - givenData[labels[1]][index]);
      data[labels[3]][index] = null;
    } else {
      data[labels[3]][index] = givenData[labels[1]][index] - item;
      data[labels[2]][index] = null;
    }
    data[labels[4]][index] = null;
  });

  let temp = data[labels[0]].map((item, index) => {
    return (
      item +
      data[labels[2]][index] +
      data[labels[3]][index] +
      data[labels[4]][index]
    );
  });

  lim = Math.max(...temp);
  lim = lim / 1000;
  lim = Math.ceil(lim) * 1000;
  lim += lim * 0.1;
  return data;
}

function chartBallText(data) {
  return (
    <>
      {data.map((item, index) => {
        return (
          <div key={index} className="chart-ball-text">
            <div
              className="ball"
              style={{
                backgroundColor: item.backgroundColor,
                height: "15px",
                width: "15px",
                borderRadius: "50%",
              }}
            ></div>
            <p>{item.label}</p>
          </div>
        );
      })}
    </>
  );
}

const ConsumptionForecast = (props) => {
  const { tableContent } = props;
  const pageDetail = tableContent.find(
    (item) => item.title === "Production Forecast With Consumption"
  );
  const roofInfo = useSelector((state) => state.roof);
  const quantityInfo = useSelector((state) => state.quantity);
  const roofData = quantityInfo?.roofData || [];
  const roofIndex = quantityInfo.roofNo;
  const check = quantityInfo.allRoof;
  const roofDetail = roofData[roofIndex];

  let month = [
    "jan",
    "feb",
    "mar",
    "apr",
    "may",
    "jun",
    "jul",
    "aug",
    "sep",
    "oct",
    "nov",
    "dec",
  ];
  let data = [];
  let monthConsumption = [];

  if (check) {
    for (let j = 0; j < 12; j++) {
      let value = 0;
      for (let i = 0; i < roofData.length; i++) {
        value += roofData[i].actualGeneration[j];
      }
      monthConsumption.push(roofInfo.value.financialAnalysis[month[j]]);
      data.push(value);
    }
  } else {
    for (let j = 0; j < 12; j++) {
      let value = roofDetail.actualGeneration[j];
      monthConsumption.push(roofInfo.value.financialAnalysis[month[j]]);
      data.push(value);
    }
  }

  let givenData = {
    [labels[0]]: data,
    [labels[1]]: monthConsumption,
  };

  const chartOneData = energyCalculations(givenData);

  let options = {
    responsive: false,

    plugins: {
      tooltip: {
        enabled: false, // <-- this option disables tooltips
      },
      legend: {
        display: false, // Hide the legend
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: { color: "#929292", font: { size: 10 }, padding: 5 },
        beginAtZero: true,
        title: {
          color: "#000",
          font: {
            size: 10,
          },
          display: true,
          text: "Month", // X-axis title
        },
        grid: {
          display: false, // Extended vertical lines below x-axis only
          drawBorder: false,
        },
      },
      y: {
        // max: lim,
        // min: -lim,
        stacked: true,
        ticks: { color: "#929292", font: { size: 10 }, padding: 10 },
        beginAtZero: true,
        title: {
          color: "#000",
          font: {
            size: 10,
          },
          display: true,
          text: "Energy in kWh", // Y-axis title
        },
        grid: {
          drawBorder: false, // <-- this removes y-axis line
        },
      },
    },
  };

  let state = {
    data: {
      labels: month,
      datasets: [
        {
          label: "PV Yeild",
          backgroundColor: "#A0D4F5",
          data: chartOneData[labels[0]],
          borderRadius: 10, // Round the top edges of bars
          barThickness: 8,
        },
        {
          label: "Consumption",
          backgroundColor: "#045097",
          data: chartOneData[labels[1]],
          borderRadius: 10, // Round the top edges of bars
          barThickness: 8,
        },
        {
          label: "Export Energy",
          backgroundColor: "#FF7F1E",
          data: chartOneData[labels[2]],
          borderRadius: 10, // Round the top edges of bars
          barThickness: 8,
        },
        {
          label: "Import Energy",
          backgroundColor: "#CDDCEA",
          data: chartOneData[labels[3]],
          borderRadius: 10, // Round the top edges of bars
          barThickness: 8,
        },
      ],
    },
  };

  let options1 = {
    responsive: false,

    plugins: {
      tooltip: {
        enabled: false, // <-- this option disables tooltips
      },
      legend: {
        display: false, // Hide the legend
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: { color: "#929292", font: { size: 10 }, padding: 5 },
        beginAtZero: true,
        title: {
          color: "#000",
          font: {
            size: 10,
          },
          display: true,
          text: "Month", // X-axis title
        },
        grid: {
          display: false, // Extended vertical lines below x-axis only
          drawBorder: false,
        },
      },
      y: {
        stacked: true,
        ticks: { color: "#929292", font: { size: 10 }, padding: 10 },
        beginAtZero: true,
        title: {
          color: "#000",
          font: {
            size: 10,
          },
          display: true,
          text: "Energy in kWh", // Y-axis title
        },
        grid: {
          drawBorder: false, // <-- this removes y-axis line
        },
      },
    },
  };

  let state1 = {
    data: {
      labels: month,
      datasets: [
        {
          stack: "Stack 0",
          label: "Consumption",
          backgroundColor: "#045097",
          data: chartOneData[labels[1]].map((item) => {
            return -item;
          }),
          borderRadius: 10, // Round the top edges of bars
          barThickness: 8,
        },
        {
          stack: "Stack 1",
          label: "PV Yeild",
          backgroundColor: "#A0D4F5",
          data: chartOneData[labels[0]],
          borderRadius: 10, // Round the top edges of bars
          barThickness: 8,
        },
        {
          stack: "Stack 1",
          label: "Import Energy",
          backgroundColor: "#CDDCEA",
          data: chartOneData[labels[3]],
          borderRadius: 10, // Round the top edges of bars
          barThickness: 8,
        },
        {
          stack: "Stack 0",
          label: "Export Energy",
          backgroundColor: "#ff7f1e",
          data: chartOneData[labels[2]].map((item) => {
            return -item;
          }),
          // data: chartOneData[labels[2]],
          borderRadius: 10, // Round the top edges of bars
          barThickness: 8,
        },
      ],
    },
  };

  return (
    <div id="consumption-forecast" className="consumption-forecast">
      {/* Patterns */}
      <Patterns />
      {/* Header */}
      <Header />
      {/* Main Body */}
      <main className="cf-body">
        <p style={{ marginTop: "20px", marginBottom: "20px" }}>
          Production Forecast with Consumption
        </p>
        <Bar height="220px" width="495px" options={options} data={state.data} />
        <div className="chart-ball-text-container">
          {chartBallText(state.data.datasets)}
        </div>
        <p style={{ marginTop: "30px", marginBottom: "20px" }}>
          Coverage of Consumption
        </p>
        <Bar
          height="220px"
          width="495px"
          options={options1}
          data={state1.data}
        />
        <div className="chart-ball-text-container">
          {chartBallText(state1.data.datasets)}
        </div>
      </main>

      {/* Footer */}
      <Footer
        pageNo={`${pageDetail ? pageDetail.pageNo : 12}/${
          tableContent[tableContent.length - 1].pageNo
        }`}
      />
    </div>
  );
};

export default ConsumptionForecast;
